// extracted by mini-css-extract-plugin
export default {"addressText":"frame__addressText__wrFEsC"};